import { __values, __decorate, __metadata, __extends } from 'tslib';
import { LazyGetter } from 'typescript-lazy-get-decorator';
import { Proto } from 'typescript-proto-decorator';
import * as lf from 'localforage';
import lf__default, {  } from 'localforage';
import { InjectionToken, Inject, Injectable, Optional, NgModule, defineInjectable, inject } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * \@internal
 * @type {?}
 */
var NC_NE_NW = Object.freeze({
    configurable: false,
    enumerable: false,
    writable: false
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * \@internal
 * @template T
 */
var CachedItemImpl = /** @class */ (function () {
    function CachedItemImpl(data, expiryTime) {
        this.data = data;
        this.expires = new Date(typeof (/** @type {?} */ (expiryTime)) === 'number' ? expiryTime : 0);
    }
    Object.defineProperty(CachedItemImpl.prototype, "expired", {
        get: /**
         * @return {?}
         */
        function () {
            return this.expiresIn === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CachedItemImpl.prototype, "expiresIn", {
        get: /**
         * @return {?}
         */
        function () {
            return Math.max(0, this.expires.getTime() - Date.now());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CachedItemImpl.prototype, "hasData", {
        get: /**
         * @return {?}
         */
        function () {
            return this.data !== null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CachedItemImpl.prototype.toJSON = /**
     * @return {?}
     */
    function () {
        return {
            data: this.data,
            expired: this.expired,
            expires: this.expires,
            expiresIn: this.expiresIn,
            hasData: this.hasData
        };
    };
    /**
     * @return {?}
     */
    CachedItemImpl.prototype.toString = /**
     * @return {?}
     */
    function () {
        return JSON.stringify(this.toJSON());
    };
    __decorate([
        Proto('CachedItem', NC_NE_NW),
        __metadata("design:type", String)
    ], CachedItemImpl.prototype, Symbol.toStringTag, void 0);
    __decorate([
        LazyGetter(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], CachedItemImpl.prototype, "expired", null);
    __decorate([
        LazyGetter(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], CachedItemImpl.prototype, "expiresIn", null);
    __decorate([
        LazyGetter(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], CachedItemImpl.prototype, "hasData", null);
    return CachedItemImpl;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * \@internal
 * @type {?}
 */
var localForage = 'defineDriver' in lf ? lf : lf__default;

var e_1, _a;
/** @enum {string} */
var Driver = {
    /** The IndexedDB driver */
    INDEXED_DB: (/** @type {?} */ (localForage.INDEXEDDB)),
    /** The localStorage driver */
    LOCAL_STORAGE: (/** @type {?} */ (localForage.LOCALSTORAGE)),
    /** The WebSQL driver */
    WEB_SQL: (/** @type {?} */ (localForage.WEBSQL)),
};
try {
    for (var _b = __values([localForage.INDEXEDDB, localForage.LOCALSTORAGE, localForage.WEBSQL]), _c = _b.next(); !_c.done; _c = _b.next()) {
        var d = _c.value;
        delete Driver[d];
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    }
    finally { if (e_1) throw e_1.error; }
}
Object.freeze(Driver);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * \@internal
 * @type {?}
 */
var DEFAULT_CONFIG = new InjectionToken('Default NgForage config');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * \@internal
 * @type {?}
 */
var $defaultConfig = Symbol('Default Config');
/**
 * Global/default configuration
 */
var NgForageConfig = /** @class */ (function () {
    function NgForageConfig(conf) {
        this[$defaultConfig] = {
            cacheTime: 300000,
            description: '',
            driver: [Driver.INDEXED_DB, Driver.WEB_SQL, Driver.LOCAL_STORAGE],
            name: 'ngForage',
            size: 4980736,
            storeName: 'ng_forage',
            version: 1
        };
        if (conf) {
            this.configure(conf);
        }
    }
    Object.defineProperty(NgForageConfig.prototype, "cacheTime", {
        /**
         * Cache time in milliseconds
         * @default 300000
         */
        get: /**
         * Cache time in milliseconds
         * \@default 300000
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (this[$defaultConfig].cacheTime));
        },
        set: /**
         * @param {?} t
         * @return {?}
         */
        function (t) {
            this[$defaultConfig].cacheTime = t;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "config", {
        /**
         * Get the compiled configuration
         */
        get: /**
         * Get the compiled configuration
         * @return {?}
         */
        function () {
            return {
                cacheTime: this.cacheTime,
                description: this.description,
                driver: this.driver,
                name: this.name,
                size: this.size,
                storeName: this.storeName,
                version: this.version
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "description", {
        /**
         * A description of the database, essentially for developer usage.
         * @default
         */
        get: /**
         * A description of the database, essentially for developer usage.
         * \@default
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (this[$defaultConfig].description));
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this[$defaultConfig].description = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "driver", {
        /**
         * The preferred driver(s) to use.
         */
        get: /**
         * The preferred driver(s) to use.
         * @return {?}
         */
        function () {
            if (typeof this[$defaultConfig].driver === 'string') {
                return (/** @type {?} */ (this[$defaultConfig].driver));
            }
            return ((/** @type {?} */ (this[$defaultConfig].driver))).slice();
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this[$defaultConfig].driver = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "name", {
        /**
         * The name of the database. May appear during storage limit prompts. Useful to use the name of your app here.
         * In localStorage, this is used as a key prefix for all keys stored in localStorage.
         * @default ngForage
         */
        get: /**
         * The name of the database. May appear during storage limit prompts. Useful to use the name of your app here.
         * In localStorage, this is used as a key prefix for all keys stored in localStorage.
         * \@default ngForage
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (this[$defaultConfig].name));
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this[$defaultConfig].name = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "size", {
        /**
         * The size of the database in bytes. Used only in WebSQL for now.
         * @default 4980736
         */
        get: /**
         * The size of the database in bytes. Used only in WebSQL for now.
         * \@default 4980736
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (this[$defaultConfig].size));
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this[$defaultConfig].size = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "storeName", {
        /**
         * The name of the datastore.
         * In IndexedDB this is the dataStore,
         * in WebSQL this is the name of the key/value table in the database.
         * Must be alphanumeric, with underscores.
         * Any non-alphanumeric characters will be converted to underscores.
         * @default ng_forage
         */
        get: /**
         * The name of the datastore.
         * In IndexedDB this is the dataStore,
         * in WebSQL this is the name of the key/value table in the database.
         * Must be alphanumeric, with underscores.
         * Any non-alphanumeric characters will be converted to underscores.
         * \@default ng_forage
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (this[$defaultConfig].storeName));
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this[$defaultConfig].storeName = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "version", {
        /**
         * The version of your database. May be used for upgrades in the future; currently unused.
         * @default 1.0
         */
        get: /**
         * The version of your database. May be used for upgrades in the future; currently unused.
         * \@default 1.0
         * @return {?}
         */
        function () {
            return (/** @type {?} */ (this[$defaultConfig].version));
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this[$defaultConfig].version = v;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Bulk-set configuration options
     * @param opts The configuration
     */
    /**
     * Bulk-set configuration options
     * @param {?} opts The configuration
     * @return {?}
     */
    NgForageConfig.prototype.configure = /**
     * Bulk-set configuration options
     * @param {?} opts The configuration
     * @return {?}
     */
    function (opts) {
        opts = opts || {};
        if (opts.driver && ((/** @type {?} */ (opts.driver))).slice) {
            opts.driver = ((/** @type {?} */ (opts.driver))).slice();
        }
        Object.assign(this[$defaultConfig], opts);
        return this;
    };
    /**
     * Define a driver
     *
     * You’ll want to make sure you accept a callback argument and that you pass the same arguments to callbacks as the
     * default drivers do. You’ll also want to resolve or reject promises.
     * Check any of the {@link https://github.com/mozilla/localForage/tree/master/src/drivers default drivers}
     * for an idea of how to implement your own, custom driver.
     * @param spec Driver spec
     */
    /**
     * Define a driver
     *
     * You’ll want to make sure you accept a callback argument and that you pass the same arguments to callbacks as the
     * default drivers do. You’ll also want to resolve or reject promises.
     * Check any of the {\@link https://github.com/mozilla/localForage/tree/master/src/drivers default drivers}
     * for an idea of how to implement your own, custom driver.
     * @param {?} spec Driver spec
     * @return {?}
     */
    NgForageConfig.prototype.defineDriver = /**
     * Define a driver
     *
     * You’ll want to make sure you accept a callback argument and that you pass the same arguments to callbacks as the
     * default drivers do. You’ll also want to resolve or reject promises.
     * Check any of the {\@link https://github.com/mozilla/localForage/tree/master/src/drivers default drivers}
     * for an idea of how to implement your own, custom driver.
     * @param {?} spec Driver spec
     * @return {?}
     */
    function (spec) {
        return localForage.defineDriver(spec);
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    NgForageConfig.prototype.toJSON = /**
     * \@internal
     * @return {?}
     */
    function () {
        return this.config;
    };
    /**
     * @return {?}
     */
    NgForageConfig.prototype.toString = /**
     * @return {?}
     */
    function () {
        return JSON.stringify(this.toJSON());
    };
    NgForageConfig.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */
    NgForageConfig.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DEFAULT_CONFIG,] }] }
    ]; };
    /** @nocollapse */ NgForageConfig.ngInjectableDef = defineInjectable({ factory: function NgForageConfig_Factory() { return new NgForageConfig(inject(DEFAULT_CONFIG, 8)); }, token: NgForageConfig, providedIn: "root" });
    __decorate([
        Proto('NgForageConfig', NC_NE_NW),
        __metadata("design:type", String)
    ], NgForageConfig.prototype, Symbol.toStringTag, void 0);
    return NgForageConfig;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * \@internal
 * @type {?}
 */
var stores = {};
/**
 * \@internal
 * @param {?=} driver
 * @return {?}
 */
function getDriverString(driver) {
    if (!driver) {
        return '';
    }
    else if (Array.isArray(driver)) {
        return driver.slice().sort().join(',');
    }
    else {
        return (/** @type {?} */ (driver));
    }
}
/**
 * \@internal
 * @param {?} cfg
 * @return {?}
 */
function getHash(cfg) {
    return [
        getDriverString(cfg.driver),
        cfg.name,
        cfg.size,
        cfg.storeName,
        cfg.version,
        cfg.description,
        cfg.cacheTime
    ].join('|');
}
/**
 * \@internal
 * @type {?}
 */
var conf$ = Symbol('Config');
/**
 * Creates localForage instances
 */
var InstanceFactory = /** @class */ (function () {
    /** @internal */
    function InstanceFactory(conf) {
        this[conf$] = conf;
    }
    /**
     * @param {?} cfg
     * @return {?}
     */
    InstanceFactory.prototype.getInstance = /**
     * @param {?} cfg
     * @return {?}
     */
    function (cfg) {
        cfg = Object.assign({}, this[conf$].config, cfg || {});
        /** @type {?} */
        var hash = getHash(cfg);
        if (!stores[hash]) {
            stores[hash] = localForage.createInstance(cfg);
        }
        return stores[hash];
    };
    InstanceFactory.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */
    InstanceFactory.ctorParameters = function () { return [
        { type: NgForageConfig }
    ]; };
    /** @nocollapse */ InstanceFactory.ngInjectableDef = defineInjectable({ factory: function InstanceFactory_Factory() { return new InstanceFactory(inject(NgForageConfig)); }, token: InstanceFactory, providedIn: "root" });
    __decorate([
        Proto('InstanceFactory', NC_NE_NW),
        __metadata("design:type", String)
    ], InstanceFactory.prototype, Symbol.toStringTag, void 0);
    return InstanceFactory;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * \@internal
 * @type {?}
 */
var store$ = Symbol('Store');
/**
 * Abstract service-level configuration layer for NgForage
 * @abstract
 */
var BaseConfigurableImpl = /** @class */ (function () {
    /** @internal */
    function BaseConfigurableImpl(config, instanceFactory) {
        /**
         * \@internal
         */
        this.config = {};
        this.baseConfig = config;
        this.fact = instanceFactory;
    }
    Object.defineProperty(BaseConfigurableImpl.prototype, "description", {
        /**
         * A description of the database, essentially for developer usage.
         * @default ""
         */
        get: /**
         * A description of the database, essentially for developer usage.
         * \@default ""
         * @return {?}
         */
        function () {
            return this.config.description || this.baseConfig.description;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.config.description = v;
            this.storeNeedsRecalc = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseConfigurableImpl.prototype, "driver", {
        /**
         * The preferred driver(s) to use.
         * @default IndexedDB, WebSQL and localStorage
         */
        get: /**
         * The preferred driver(s) to use.
         * \@default IndexedDB, WebSQL and localStorage
         * @return {?}
         */
        function () {
            return this.config.driver || this.baseConfig.driver;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.config.driver = v;
            this.storeNeedsRecalc = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseConfigurableImpl.prototype, "name", {
        /**
         * The name of the database. May appear during storage limit prompts. Useful to use the name of your app here.
         * In localStorage, this is used as a key prefix for all keys stored in localStorage.
         * @default ngForage
         */
        get: /**
         * The name of the database. May appear during storage limit prompts. Useful to use the name of your app here.
         * In localStorage, this is used as a key prefix for all keys stored in localStorage.
         * \@default ngForage
         * @return {?}
         */
        function () {
            return this.config.name || this.baseConfig.name;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.config.name = v;
            this.storeNeedsRecalc = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseConfigurableImpl.prototype, "size", {
        /**
         * The size of the database in bytes. Used only in WebSQL for now.
         * @default 4980736
         */
        get: /**
         * The size of the database in bytes. Used only in WebSQL for now.
         * \@default 4980736
         * @return {?}
         */
        function () {
            return this.config.size || this.baseConfig.size;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.config.size = v;
            this.storeNeedsRecalc = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseConfigurableImpl.prototype, "storeName", {
        /**
         * The name of the datastore.
         * In IndexedDB this is the dataStore,
         * in WebSQL this is the name of the key/value table in the database.
         * Must be alphanumeric, with underscores.
         * Any non-alphanumeric characters will be converted to underscores.
         * @default ng_forage
         */
        get: /**
         * The name of the datastore.
         * In IndexedDB this is the dataStore,
         * in WebSQL this is the name of the key/value table in the database.
         * Must be alphanumeric, with underscores.
         * Any non-alphanumeric characters will be converted to underscores.
         * \@default ng_forage
         * @return {?}
         */
        function () {
            return this.config.storeName || this.baseConfig.storeName;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.config.storeName = v;
            this.storeNeedsRecalc = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseConfigurableImpl.prototype, "version", {
        /**
         * The version of your database. May be used for upgrades in the future; currently unused.
         * @default 1.0
         */
        get: /**
         * The version of your database. May be used for upgrades in the future; currently unused.
         * \@default 1.0
         * @return {?}
         */
        function () {
            return 'version' in this.config ? (/** @type {?} */ (this.config.version)) : this.baseConfig.version;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.config.version = v;
            this.storeNeedsRecalc = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseConfigurableImpl.prototype, "finalConfig", {
        /** @internal */
        get: /**
         * \@internal
         * @return {?}
         */
        function () {
            return Object.assign({}, this.baseConfig.config, this.config);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseConfigurableImpl.prototype, "store", {
        /** @internal */
        get: /**
         * \@internal
         * @return {?}
         */
        function () {
            if (this.storeNeedsRecalc || !this[store$]) {
                this[store$] = this.fact.getInstance(this.finalConfig);
                this.storeNeedsRecalc = false;
            }
            return this[store$];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Bulk-set configuration options
     * @param opts The configuration
     */
    /**
     * Bulk-set configuration options
     * @param {?} opts The configuration
     * @return {?}
     */
    BaseConfigurableImpl.prototype.configure = /**
     * Bulk-set configuration options
     * @param {?} opts The configuration
     * @return {?}
     */
    function (opts) {
        opts = opts || {};
        if (Array.isArray(opts.driver)) {
            opts.driver = opts.driver.slice();
        }
        Object.assign(this.config, opts);
        this.storeNeedsRecalc = true;
        return this;
    };
    /**
     * @return {?}
     */
    BaseConfigurableImpl.prototype.toJSON = /**
     * @return {?}
     */
    function () {
        return {
            description: this.description,
            driver: this.driver,
            name: this.name,
            size: this.size,
            storeName: this.storeName,
            version: this.version
        };
    };
    /**
     * @return {?}
     */
    BaseConfigurableImpl.prototype.toString = /**
     * @return {?}
     */
    function () {
        return JSON.stringify(this.toJSON());
    };
    /** @nocollapse */
    BaseConfigurableImpl.ctorParameters = function () { return [
        { type: NgForageConfig, decorators: [{ type: Inject, args: [NgForageConfig,] }] },
        { type: InstanceFactory, decorators: [{ type: Inject, args: [InstanceFactory,] }] }
    ]; };
    __decorate([
        Proto('BaseConfigurable', NC_NE_NW),
        __metadata("design:type", String)
    ], BaseConfigurableImpl.prototype, Symbol.toStringTag, void 0);
    __decorate([
        Proto(true),
        __metadata("design:type", Boolean)
    ], BaseConfigurableImpl.prototype, "storeNeedsRecalc", void 0);
    return BaseConfigurableImpl;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Cache instance
 */
var NgForage = /** @class */ (function (_super) {
    __extends(NgForage, _super);
    function NgForage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(NgForage.prototype, "activeDriver", {
        /**
         * Returns the name of the driver being used, or null if none can be used.
         */
        get: /**
         * Returns the name of the driver being used, or null if none can be used.
         * @return {?}
         */
        function () {
            return this.store.driver();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Removes every key from the database, returning it to a blank slate.
     *
     * clear() will remove <b>every item in the offline store</b>. Use this method with caution.
     */
    /**
     * Removes every key from the database, returning it to a blank slate.
     *
     * clear() will remove <b>every item in the offline store</b>. Use this method with caution.
     * @return {?}
     */
    NgForage.prototype.clear = /**
     * Removes every key from the database, returning it to a blank slate.
     *
     * clear() will remove <b>every item in the offline store</b>. Use this method with caution.
     * @return {?}
     */
    function () {
        return this.store.clear();
    };
    /**
     * Make a clone of the instance
     * @param config Optional configuration
     */
    /**
     * Make a clone of the instance
     * @param {?=} config Optional configuration
     * @return {?}
     */
    NgForage.prototype.clone = /**
     * Make a clone of the instance
     * @param {?=} config Optional configuration
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var inst = new NgForage(this.baseConfig, this.fact);
        inst.configure(Object.assign(this.finalConfig, config || {}));
        return inst;
    };
    /**
     * Gets an item from the storage library.
     * If the key does not exist, getItem() will return null.
     * @param key Data key
     */
    /**
     * Gets an item from the storage library.
     * If the key does not exist, getItem() will return null.
     * @template T
     * @param {?} key Data key
     * @return {?}
     */
    NgForage.prototype.getItem = /**
     * Gets an item from the storage library.
     * If the key does not exist, getItem() will return null.
     * @template T
     * @param {?} key Data key
     * @return {?}
     */
    function (key) {
        return this.store.getItem(key);
    };
    /**
     * Iterate over all value/key pairs in datastore.
     * <i>iteratee</i> is called once for each pair, with the following arguments:
     * <ol>
     *   <li>Value</li>
     *   <li>Key</li>
     *   <li>iterationNumber - one-based number</li>
     * </ol>
     * iterate() supports early exit by returning non undefined value inside iteratorCallback callback.
     * @param iteratee
     */
    /**
     * Iterate over all value/key pairs in datastore.
     * <i>iteratee</i> is called once for each pair, with the following arguments:
     * <ol>
     *   <li>Value</li>
     *   <li>Key</li>
     *   <li>iterationNumber - one-based number</li>
     * </ol>
     * iterate() supports early exit by returning non undefined value inside iteratorCallback callback.
     * @template T, U
     * @param {?} iteratee
     * @return {?}
     */
    NgForage.prototype.iterate = /**
     * Iterate over all value/key pairs in datastore.
     * <i>iteratee</i> is called once for each pair, with the following arguments:
     * <ol>
     *   <li>Value</li>
     *   <li>Key</li>
     *   <li>iterationNumber - one-based number</li>
     * </ol>
     * iterate() supports early exit by returning non undefined value inside iteratorCallback callback.
     * @template T, U
     * @param {?} iteratee
     * @return {?}
     */
    function (iteratee) {
        return this.store.iterate(iteratee);
    };
    /**
     * Get the name of a key based on its ID.
     * @param index
     */
    /**
     * Get the name of a key based on its ID.
     * @param {?} index
     * @return {?}
     */
    NgForage.prototype.key = /**
     * Get the name of a key based on its ID.
     * @param {?} index
     * @return {?}
     */
    function (index) {
        return this.store.key(index);
    };
    /**
     * Get the list of all keys in the datastore.
     */
    /**
     * Get the list of all keys in the datastore.
     * @return {?}
     */
    NgForage.prototype.keys = /**
     * Get the list of all keys in the datastore.
     * @return {?}
     */
    function () {
        return this.store.keys();
    };
    /**
     * Gets the number of keys in the offline store (i.e. its “length”).
     */
    /**
     * Gets the number of keys in the offline store (i.e. its “length”).
     * @return {?}
     */
    NgForage.prototype.length = /**
     * Gets the number of keys in the offline store (i.e. its “length”).
     * @return {?}
     */
    function () {
        return this.store.length();
    };
    /**
     * Even though localForage queues up all of its data API method calls,
     * ready() provides a way to determine whether the asynchronous driver initialization process has finished.
     * That’s useful in cases like when we want to know which driver localForage has settled down using.
     */
    /**
     * Even though localForage queues up all of its data API method calls,
     * ready() provides a way to determine whether the asynchronous driver initialization process has finished.
     * That’s useful in cases like when we want to know which driver localForage has settled down using.
     * @return {?}
     */
    NgForage.prototype.ready = /**
     * Even though localForage queues up all of its data API method calls,
     * ready() provides a way to determine whether the asynchronous driver initialization process has finished.
     * That’s useful in cases like when we want to know which driver localForage has settled down using.
     * @return {?}
     */
    function () {
        return this.store.ready();
    };
    /**
     * Removes the value of a key from the offline store.
     * @param key Data key
     */
    /**
     * Removes the value of a key from the offline store.
     * @param {?} key Data key
     * @return {?}
     */
    NgForage.prototype.removeItem = /**
     * Removes the value of a key from the offline store.
     * @param {?} key Data key
     * @return {?}
     */
    function (key) {
        return this.store.removeItem(key);
    };
    /**
     * Saves data to an offline store. You can store the following types of JavaScript objects:
     * <ul>
     *  <li>Array</li>
     *  <li>ArrayBuffer</li>
     *  <li>Blob</li>
     *  <li>Float32Array</li>
     *  <li>Float64Array</li>
     *  <li>Int8Array</li>
     *  <li>Int16Array</li>
     *  <li>Int32Array</li>
     *  <li>Number</li>
     *  <li>Object</li>
     *  <li>Uint8Array</li>
     *  <li>Uint8ClampedArray</li>
     *  <li>Uint16Array</li>
     *  <li>Uint32Array</li>
     *  <li>String</li>
     * </ul>
     * @param key Data key
     * @param data Data
     */
    /**
     * Saves data to an offline store. You can store the following types of JavaScript objects:
     * <ul>
     *  <li>Array</li>
     *  <li>ArrayBuffer</li>
     *  <li>Blob</li>
     *  <li>Float32Array</li>
     *  <li>Float64Array</li>
     *  <li>Int8Array</li>
     *  <li>Int16Array</li>
     *  <li>Int32Array</li>
     *  <li>Number</li>
     *  <li>Object</li>
     *  <li>Uint8Array</li>
     *  <li>Uint8ClampedArray</li>
     *  <li>Uint16Array</li>
     *  <li>Uint32Array</li>
     *  <li>String</li>
     * </ul>
     * @template T
     * @param {?} key Data key
     * @param {?} data Data
     * @return {?}
     */
    NgForage.prototype.setItem = /**
     * Saves data to an offline store. You can store the following types of JavaScript objects:
     * <ul>
     *  <li>Array</li>
     *  <li>ArrayBuffer</li>
     *  <li>Blob</li>
     *  <li>Float32Array</li>
     *  <li>Float64Array</li>
     *  <li>Int8Array</li>
     *  <li>Int16Array</li>
     *  <li>Int32Array</li>
     *  <li>Number</li>
     *  <li>Object</li>
     *  <li>Uint8Array</li>
     *  <li>Uint8ClampedArray</li>
     *  <li>Uint16Array</li>
     *  <li>Uint32Array</li>
     *  <li>String</li>
     * </ul>
     * @template T
     * @param {?} key Data key
     * @param {?} data Data
     * @return {?}
     */
    function (key, data) {
        return this.store.setItem(key, data);
    };
    /**
     * Check whether the given driver is supported/registered.
     * @param driver Driver name
     */
    /**
     * Check whether the given driver is supported/registered.
     * @param {?} driver Driver name
     * @return {?}
     */
    NgForage.prototype.supports = /**
     * Check whether the given driver is supported/registered.
     * @param {?} driver Driver name
     * @return {?}
     */
    function (driver) {
        return this.store.supports((/** @type {?} */ (driver)));
    };
    NgForage.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */ NgForage.ngInjectableDef = defineInjectable({ factory: function NgForage_Factory() { return new NgForage(inject(NgForageConfig), inject(InstanceFactory)); }, token: NgForage, providedIn: "root" });
    __decorate([
        Proto('NgForage', NC_NE_NW),
        __metadata("design:type", String)
    ], NgForage.prototype, Symbol.toStringTag, void 0);
    return NgForage;
}(BaseConfigurableImpl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * \@internal
 * @param {?} mainKey
 * @return {?}
 */
function calculateCacheKeys(mainKey) {
    return {
        data: mainKey + "_data",
        expiry: mainKey + "_expiry"
    };
}
/**
 * \@internal
 * @template T
 * @param {?} r
 * @return {?}
 */
function toCachedItem(r) {
    return new CachedItemImpl(r[0], r[1]);
}
/**
 * \@internal
 * @template T
 * @param {?} r
 * @return {?}
 */
function head(r) {
    return r[0];
}
/**
 * \@internal
 * @return {?}
 */
// tslint:disable-next-line:no-empty
function toVoid() {
}
/**
 * An extension of {\@link NgForage} which adds expiration support
 */
var NgForageCache = /** @class */ (function (_super) {
    __extends(NgForageCache, _super);
    function NgForageCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(NgForageCache.prototype, "cacheTime", {
        /**
         * Cache time in milliseconds
         * @default 300000
         */
        get: /**
         * Cache time in milliseconds
         * \@default 300000
         * @return {?}
         */
        function () {
            return this.config.cacheTime || this.baseConfig.cacheTime;
        },
        set: /**
         * @param {?} t
         * @return {?}
         */
        function (t) {
            this.config.cacheTime = t;
            this.storeNeedsRecalc = true;
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    /**
     * @inheritDoc
     * @param {?=} config
     * @return {?}
     */
    NgForageCache.prototype.clone = /**
     * @inheritDoc
     * @param {?=} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var inst = new NgForageCache(this.baseConfig, this.fact);
        inst.configure(Object.assign(this.finalConfig, config || {}));
        return inst;
    };
    /**
     * Retrieve data
     * @param key Data key
     */
    /**
     * Retrieve data
     * @template T
     * @param {?} key Data key
     * @return {?}
     */
    NgForageCache.prototype.getCached = /**
     * Retrieve data
     * @template T
     * @param {?} key Data key
     * @return {?}
     */
    function (key) {
        /** @type {?} */
        var keys = calculateCacheKeys(key);
        /** @type {?} */
        var dataPromise = this.getItem(keys.data);
        /** @type {?} */
        var expiryPromise = this.getItem(keys.expiry);
        return Promise.all([dataPromise, expiryPromise]).then(toCachedItem);
    };
    /**
     * Remove data
     * @param key Data key
     */
    /**
     * Remove data
     * @param {?} key Data key
     * @return {?}
     */
    NgForageCache.prototype.removeCached = /**
     * Remove data
     * @param {?} key Data key
     * @return {?}
     */
    function (key) {
        /** @type {?} */
        var keys = calculateCacheKeys(key);
        /** @type {?} */
        var dataPromise = this.removeItem(keys.data);
        /** @type {?} */
        var expiryPromise = this.removeItem(keys.expiry);
        return Promise.all([dataPromise, expiryPromise]).then(toVoid);
    };
    /**
     * Set data
     * @param key Data key
     * @param data Data to set
     * @param [cacheTime] Override cache set in {@link CacheConfigurable#cacheTime global or instance config}.
     */
    /**
     * Set data
     * @template T
     * @param {?} key Data key
     * @param {?} data Data to set
     * @param {?=} cacheTime
     * @return {?}
     */
    NgForageCache.prototype.setCached = /**
     * Set data
     * @template T
     * @param {?} key Data key
     * @param {?} data Data to set
     * @param {?=} cacheTime
     * @return {?}
     */
    function (key, data, cacheTime) {
        /** @type {?} */
        var keys = calculateCacheKeys(key);
        /** @type {?} */
        var expiry = typeof cacheTime === 'number' ? cacheTime : this.cacheTime;
        /** @type {?} */
        var dataPromise = this.setItem(keys.data, data);
        /** @type {?} */
        var expiryPromise = this.setItem(keys.expiry, Date.now() + expiry);
        return Promise.all([dataPromise, expiryPromise]).then(head);
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    NgForageCache.prototype.toJSON = /**
     * \@internal
     * @return {?}
     */
    function () {
        /** @type {?} */
        var ass = { cacheTime: this.cacheTime };
        return Object.assign(_super.prototype.toJSON.call(this), ass);
    };
    NgForageCache.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */ NgForageCache.ngInjectableDef = defineInjectable({ factory: function NgForageCache_Factory() { return new NgForageCache(inject(NgForageConfig), inject(InstanceFactory)); }, token: NgForageCache, providedIn: "root" });
    __decorate([
        Proto('NgForageCache', NC_NE_NW),
        __metadata("design:type", String)
    ], NgForageCache.prototype, Symbol.toStringTag, void 0);
    return NgForageCache;
}(NgForage));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * \@internal
 */
var NgForageCacheDedicated = /** @class */ (function (_super) {
    __extends(NgForageCacheDedicated, _super);
    function NgForageCacheDedicated() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?=} config
     * @return {?}
     */
    NgForageCacheDedicated.prototype.clone = /**
     * @param {?=} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var inst = new NgForageCacheDedicated(this.baseConfig, this.fact);
        inst.configure(Object.assign(this.finalConfig, config || {}));
        return inst;
    };
    __decorate([
        Proto('NgForageCache (dedicated)', NC_NE_NW),
        __metadata("design:type", String)
    ], NgForageCacheDedicated.prototype, Symbol.toStringTag, void 0);
    return NgForageCacheDedicated;
}(NgForageCache));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * \@internal
 */
var NgForageDedicated = /** @class */ (function (_super) {
    __extends(NgForageDedicated, _super);
    function NgForageDedicated() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?=} config
     * @return {?}
     */
    NgForageDedicated.prototype.clone = /**
     * @param {?=} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var inst = new NgForageDedicated(this.baseConfig, this.fact);
        inst.configure(Object.assign(this.finalConfig, config || {}));
        return inst;
    };
    __decorate([
        Proto('NgForage (dedicated)', NC_NE_NW),
        __metadata("design:type", String)
    ], NgForageDedicated.prototype, Symbol.toStringTag, void 0);
    return NgForageDedicated;
}(NgForage));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * \@internal
 * @type {?}
 */
var conf$$1 = Symbol('NgForageConfig');
/**
 * \@internal
 * @type {?}
 */
var if$ = Symbol('InstanceFactory');
var DedicatedInstanceFactory = /** @class */ (function () {
    function DedicatedInstanceFactory(conf, instFact) {
        this[conf$$1] = conf;
        this[if$] = instFact;
    }
    /**
     * @param {?=} config
     * @return {?}
     */
    DedicatedInstanceFactory.prototype.createCache = /**
     * @param {?=} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var inst = new NgForageCacheDedicated(this[conf$$1], this[if$]);
        if (config) {
            inst.configure(config);
        }
        return inst;
    };
    /**
     * @param {?=} config
     * @return {?}
     */
    DedicatedInstanceFactory.prototype.createNgForage = /**
     * @param {?=} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var inst = new NgForageDedicated(this[conf$$1], this[if$]);
        if (config) {
            inst.configure(config);
        }
        return inst;
    };
    DedicatedInstanceFactory.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */
    DedicatedInstanceFactory.ctorParameters = function () { return [
        { type: NgForageConfig },
        { type: InstanceFactory }
    ]; };
    /** @nocollapse */ DedicatedInstanceFactory.ngInjectableDef = defineInjectable({ factory: function DedicatedInstanceFactory_Factory() { return new DedicatedInstanceFactory(inject(NgForageConfig), inject(InstanceFactory)); }, token: DedicatedInstanceFactory, providedIn: "root" });
    __decorate([
        Proto('DedicatedInstanceFactory', NC_NE_NW),
        __metadata("design:type", String)
    ], DedicatedInstanceFactory.prototype, Symbol.toStringTag, void 0);
    return DedicatedInstanceFactory;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * NgForage core module
 */
var NgForageModule = /** @class */ (function () {
    function NgForageModule() {
    }
    // istanbul ignore next
    // istanbul ignore next
    /**
     * @param {?=} config
     * @return {?}
     */
    NgForageModule.forRoot = 
    // istanbul ignore next
    /**
     * @param {?=} config
     * @return {?}
     */
    function (config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: NgForageModule,
            providers: [
                {
                    provide: DEFAULT_CONFIG,
                    useValue: Object.assign({}, config)
                }
            ]
        };
    };
    NgForageModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return NgForageModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { CachedItemImpl, NgForageCache, BaseConfigurableImpl, NgForageConfig, DedicatedInstanceFactory, NgForageCacheDedicated, NgForageDedicated, InstanceFactory, NgForage, NgForageModule, Driver };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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